import { render, staticRenderFns } from "./PriceBeardo.vue?vue&type=template&id=84ba9968&scoped=true"
import script from "./PriceBeardo.vue?vue&type=script&lang=js"
export * from "./PriceBeardo.vue?vue&type=script&lang=js"
import style0 from "./PriceBeardo.vue?vue&type=style&index=0&id=84ba9968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ba9968",
  null
  
)

export default component.exports